module.exports = __webpack_public_path__ + "img/Talk Graphic 7.0b7e0858.png";